module.exports = __webpack_public_path__ + "static/img/folder-gray.9f3b0339.png";